import { Button, Card, Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { Header, PageWrapper } from "src/shared/components";
import { EVENT_ID } from "src/shared/constants/event";
import { mediaQueries } from "src/theme/deviceBreakpoints";

import { VOLUNTEER_LEADS, VOLUNTEER_ORGANIZER } from "./constants";
import ContactCard from "./ContactCard";
import { useMarkOwnHandbookAsReadMutation } from "./graphql/markOwnHandbookAsRead.generated";

const ContactPage = () => {
  const [markOwnHandbookAsReadMutation] = useMarkOwnHandbookAsReadMutation({
    variables: {
      event_id: EVENT_ID,
    },
  });

  return (
    <>
      <Header
        title="Contact"
        subtitle="Do you have any questions? Contact any of these wonderful people if you have any questions!"
      />
      <PageWrapper fullWidth>
        <CardContainer>
          <StyledCard>
            <CardContent>
              <Text type="h2">Volunteer Handbook</Text>
              <Text>
                Read and access the volunteer handbook - it is our central
                source of information!
              </Text>
              <a
                href="https://docs.google.com/document/d/18cQ2Fg4mCD6xc8u5QBWCvAHXK5w4j660fHV0uU3ZRcA/edit?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  size="md"
                  color="secondary"
                  onClick={() => {
                    markOwnHandbookAsReadMutation();
                  }}
                >
                  Open Handbook
                </Button>
              </a>
            </CardContent>
          </StyledCard>
        </CardContainer>
        <LargeSpacer />
        <Text type="h1">Volunteer Contact Info</Text>
        <Spacer />
        {VOLUNTEER_ORGANIZER.map((organizer) => (
          <ContactCard
            key={organizer.name}
            name={organizer.name}
            title={organizer.title}
            email={organizer.email}
          />
        ))}
        <LargeSpacer />
        <Text type="h1">Volunteer Leads</Text>
        <Spacer />
        <VolunteerContainer>
          {VOLUNTEER_LEADS.map((lead) => (
            <ContactCard
              key={lead.name}
              name={lead.name}
              title={lead.title}
              email={lead.email}
            />
          ))}
        </VolunteerContainer>
      </PageWrapper>
    </>
  );
};

const StyledCard = styled(Card)`
  display: flex;
  width: 432px;
  height: auto;
  padding: 24px 32px;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CardContainer = styled.div`
  display: flex;
  align-items: stretch;
  gap: 42px;
`;

const VolunteerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 298px);
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;

  ${mediaQueries.medium} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQueries.largeMobile} {
    display: flex;
    flex-direction: column;
  }
`;

const Spacer = styled.div`
  height: 24px;
`;

const LargeSpacer = styled.div`
  height: 40px;
`;

export default ContactPage;
